import React, { useContext, useEffect, useState } from "react";
import styles from "./Cart.module.scss";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../stores/RootStore";
import { useSearchParams } from "react-router-dom";
import { Dropdown, DropdownButton } from "react-bootstrap";
import Button from "../../../components/Button";
import moment from "moment";
import Modal from "components/Modal";

const CartAssemblyTasks: React.FC = observer(() => {
  const {
    orderStore: {
      getAssemblyTask,
      getWarehouseShipmentActs,
      approveWarehouseShipmentActs,
    },
    yandexStore: { ApproveYandexShipment, getYandexStocks, yandexStocks },
    ozonStore: { ApproveOzonShipment, getOzonStocks, ozonStocks },
    wildberriesStore: { ApproveWildberriesShipment },
    userStore: { info, userInfo },
  } = useContext(RootStoreContext);

  const [buttonLoading, setButtonLoading] = useState<boolean>(false);

  const [yandexAssemblyTask, setYandexAssemblyTask] = useState<any>(null);
  const [ozonAssemblyTask, setOzonAssemblyTask] = useState<any>(null);
  const [wildberriesAssemblyTask, setWildberriesAssemblyTask] =
    useState<any>(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const seller = searchParams.get("seller");
  const mpWarehouseID =
    info?.roles.includes("WarehouseOwner") && !info?.roles.includes("Seller")
      ? Number(userInfo?.mpWarehouseID).toString()
      : searchParams.get("mpWarehouseID");
  const marketplace = searchParams.get("marketplace");

  const [modalMarketplace, setModalMarketplace] = useState<number | null>(null);

  const [startDate, setStartDate] = useState<string>(
    moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState<string>(moment().format("YYYY-MM-DD"));

  useEffect(() => {
    if (seller) {
      getAssemblyTask(seller, 1).then((i) => {
        if (i) {
          setOzonAssemblyTask(window.URL.createObjectURL(new Blob([i])));
        }
      });
      getAssemblyTask(seller, 2).then((i) => {
        if (i) {
          setYandexAssemblyTask(window.URL.createObjectURL(new Blob([i])));
        }
      });
      getAssemblyTask(seller, 3).then((i) => {
        if (i) {
          setWildberriesAssemblyTask(window.URL.createObjectURL(new Blob([i])));
        }
      });
    }
  }, [
    getAssemblyTask,
    seller,
    getWarehouseShipmentActs,
    mpWarehouseID,
    marketplace,
  ]);

  useEffect(() => {
    if (info) {
      getOzonStocks(info.id);
      getYandexStocks(info.id);
    }
  }, [info, getYandexStocks, getOzonStocks]);
  console.log(seller, marketplace, mpWarehouseID);
  return (
    <>
      {seller ? (
        <DropdownButton
          title="Скачать сборочные задания"
          className={styles.downloadList}
        >
          {ozonAssemblyTask ? (
            <Dropdown.Item
              eventKey={1}
              onClick={() => {
                const a = document.createElement("a");
                a.href = ozonAssemblyTask;
                a.download = "ozonAssemblyTask.pdf";
                document.body.appendChild(a);
                a.click();
              }}
            >
              Ozon
            </Dropdown.Item>
          ) : (
            ""
          )}
          {yandexAssemblyTask ? (
            <Dropdown.Item
              eventKey={2}
              onClick={() => {
                const a = document.createElement("a");
                a.href = yandexAssemblyTask;
                a.download = "yandexMarketAssemblyTask.pdf";
                document.body.appendChild(a);
                a.click();
              }}
            >
              Yandex Market
            </Dropdown.Item>
          ) : (
            ""
          )}
          {wildberriesAssemblyTask ? (
            <Dropdown.Item
              eventKey={3}
              onClick={() => {
                const a = document.createElement("a");
                a.href = wildberriesAssemblyTask;
                a.download = "wildberriesAssemblyTask.pdf";
                document.body.appendChild(a);
                a.click();
              }}
            >
              Wildberries
            </Dropdown.Item>
          ) : (
            ""
          )}
        </DropdownButton>
      ) : (
        ""
      )}
      {seller && marketplace && mpWarehouseID ? (
        <div
          className={
            buttonLoading ? styles.approveButtonLoading : styles.approveButton
          }
        >
          <Button
            name="approve"
            onClick={() => {
              if (Number(marketplace) === 1 && mpWarehouseID) {
                setButtonLoading(true);
                ApproveOzonShipment(seller, +mpWarehouseID).then(() => {
                  setButtonLoading(false);
                });
              } else if (Number(marketplace) === 2 && yandexStocks) {
                setButtonLoading(true);
                yandexStocks.map(({ item1 }) => {
                  ApproveYandexShipment(seller, item1).then(() => {
                    setButtonLoading(false);
                  });
                });
              } else if (Number(marketplace) === 3) {
                setModalMarketplace(Number(marketplace));
              }
            }}
          >
            Подтвердить акт отгрузки
          </Button>
        </div>
      ) : (
        ""
      )}
      {marketplace && mpWarehouseID && !seller ? (
        <>
          <div className={styles.approveButton}>
            <Button
              onClick={() => {
                setModalMarketplace(10);
              }}
            >
              Скачать акт отгрузки на складе
            </Button>
          </div>

          <div
            className={
              buttonLoading ? styles.approveButtonLoading : styles.approveButton
            }
          >
            <Button
              name="approve"
              onClick={() => {
                setModalMarketplace(11);
              }}
            >
              Подтвердить акт отгрузки на складе
            </Button>
          </div>
        </>
      ) : (
        ""
      )}
      {modalMarketplace && (
        <Modal
          className={styles.cartModal}
          children={
            <div className={styles.dateModalRoot}>
              <div className={styles.dates}>
                <div>
                  <div>Период</div>
                  <div>
                    от:
                    {
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => {
                          setStartDate(e.target.value);
                        }}
                      />
                    }
                  </div>

                  <div>
                    до:
                    {
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => {
                          setEndDate(e.target.value);
                        }}
                      />
                    }
                  </div>
                </div>
              </div>
              <Button
                text={modalMarketplace === 10 ? "Скачать" : "Подтвердить"}
                color="primary"
                className={
                  buttonLoading ? styles.payButtonLoad : styles.payButton
                }
                onClick={() => {
                  switch (modalMarketplace) {
                    case 3:
                      if (seller && mpWarehouseID) {
                        setButtonLoading(true);
                        ApproveWildberriesShipment(
                          seller,
                          mpWarehouseID,
                          startDate,
                          endDate
                        ).then(() => {
                          setButtonLoading(false);
                        });
                      }
                      break;
                    case 10:
                      if (marketplace && mpWarehouseID) {
                        setButtonLoading(true);
                        getWarehouseShipmentActs(
                          Number(mpWarehouseID),
                          Number(marketplace),
                          startDate,
                          endDate
                        ).then((i) => {
                          setButtonLoading(false);
                          const a = document.createElement("a");
                          a.href = window.URL.createObjectURL(new Blob([i]));
                          a.download = "warehouseShipmentActs.pdf";
                          document.body.appendChild(a);
                          a.click();
                        });
                      }
                      break;
                    case 11:
                      setButtonLoading(true);
                      approveWarehouseShipmentActs(
                        Number(mpWarehouseID),
                        Number(marketplace),
                        startDate,
                        endDate
                      ).then(() => {
                        setButtonLoading(false);
                      });
                      break;
                    default:
                  }
                }}
              />
            </div>
          }
          isOpen={modalMarketplace !== null}
          onClose={() => {
            setModalMarketplace(null);
          }}
        />
      )}
    </>
  );
});
export default CartAssemblyTasks;
